// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"578d19ad","455":"6e579cb8","874":"7eaf8432","977":"81cbae03"}[chunkId] + ".chunk.js";
};